import React, { useEffect, useState, useRef } from 'react';
import { pricingData } from '../data/pricingData';
export function PastQuotes({
  userEmail,
  priceType,
  autoSelectQuoteId,
  onQuoteSelected
}) {
  const [quotes, setQuotes] = useState([]);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const quoteRefs = useRef({});
  useEffect(() => {
    loadQuotes();
  }, [userEmail]);
  useEffect(() => {
    if (autoSelectQuoteId && quotes.length > 0) {
      const quoteIndex = quotes.findIndex(q => q.id === autoSelectQuoteId);
      if (quoteIndex !== -1) {
        setSelectedQuote(quoteIndex);
        setTimeout(() => {
          const quoteElement = quoteRefs.current[quoteIndex];
          if (quoteElement) {
            quoteElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
          if (onQuoteSelected) {
            onQuoteSelected();
          }
        }, 100);
      }
    }
  }, [autoSelectQuoteId, quotes]);
  const loadQuotes = () => {
    const savedQuotes = localStorage.getItem('my_quotes');
    if (savedQuotes) {
      const quotes = JSON.parse(savedQuotes);
      setQuotes(quotes.sort((a, b) => new Date(b.date) - new Date(a.date)));
    }
  };
  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const formatCurrency = amount => {
    return `$${parseFloat(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };
  return <div className="bg-white rounded-lg shadow-xl p-6" data-id="element-112">
      <h2 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-113">Past Quotes</h2>
      {quotes.length === 0 ? <div className="text-center py-12 text-gray-500" data-id="element-114">
          <p className="text-lg" data-id="element-115">No past quotes found</p>
          <p className="text-sm mt-2" data-id="element-116">Submit a quote to see it appear here</p>
        </div> : <div className="space-y-4" data-id="element-117">
          {quotes.map((quote, index) => <div key={index} ref={el => quoteRefs.current[index] = el} className={`border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer ${selectedQuote === index ? 'border-blue-500 border-2' : 'border-gray-200'}`} onClick={() => setSelectedQuote(selectedQuote === index ? null : index)} data-id="element-118">
              <div className="flex justify-between items-center" data-id="element-119">
                <div data-id="element-120">
                  <p className="font-semibold text-gray-800" data-id="element-121">
                    Quote #{quotes.length - index}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-122">
                    {formatDate(quote.date)}
                  </p>
                </div>
                <div className="text-right" data-id="element-123">
                  <p className="text-xl font-bold text-blue-600" data-id="element-124">
                    {formatCurrency(quote.total)}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-125">
                    {Object.keys(quote.cart).length} item(s)
                  </p>
                </div>
              </div>
              {selectedQuote === index && <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-126">
                  <h3 className="font-semibold text-gray-800 mb-3" data-id="element-127">
                    Quote Details
                  </h3>
                  <div className="mb-4" data-id="element-128">
                    <h4 className="font-medium text-gray-700 mb-2" data-id="element-129">
                      Customer Information
                    </h4>
                    <div className="text-sm text-gray-600 space-y-1" data-id="element-130">
                      <p data-id="element-131">
                        <span className="font-medium" data-id="element-132">Name:</span>{' '}
                        {quote.customer.name}
                      </p>
                      <p data-id="element-133">
                        <span className="font-medium" data-id="element-134">Email:</span>{' '}
                        {quote.customer.email}
                      </p>
                      <p data-id="element-135">
                        <span className="font-medium" data-id="element-136">Phone:</span>{' '}
                        {quote.customer.phone}
                      </p>
                      <p data-id="element-137">
                        <span className="font-medium" data-id="element-138">State:</span>{' '}
                        {quote.customer.state}
                      </p>
                      {quote.customer.address && <p data-id="element-139">
                          <span className="font-medium" data-id="element-140">Address:</span>{' '}
                          {quote.customer.address}
                        </p>}
                      {quote.customer.city && <p data-id="element-141">
                          <span className="font-medium" data-id="element-142">City:</span>{' '}
                          {quote.customer.city}
                        </p>}
                      {quote.customer.zip && <p data-id="element-143">
                          <span className="font-medium" data-id="element-144">ZIP:</span>{' '}
                          {quote.customer.zip}
                        </p>}
                    </div>
                  </div>
                  <div data-id="element-145">
                    <h4 className="font-medium text-gray-700 mb-2" data-id="element-146">Items</h4>
                    <div className="space-y-2" data-id="element-147">
                      {Object.entries(quote.cart).map(([itemId, quantity]) => {
                const item = pricingData.find(p => p.id === itemId);
                if (!item) return null;
                return <div key={itemId} className="flex justify-between text-sm" data-id="element-148">
                            <span className="text-gray-700" data-id="element-149">
                              {item.name} x {quantity}
                            </span>
                            <span className="font-medium text-gray-800" data-id="element-150">
                              {formatCurrency(item[priceType] * quantity)}
                            </span>
                          </div>;
              })}
                      <div className="pt-2 border-t border-gray-200 flex justify-between font-bold" data-id="element-151">
                        <span data-id="element-152">Total</span>
                        <span className="text-blue-600" data-id="element-153">
                          {formatCurrency(quote.total)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>)}
        </div>}
    </div>;
}